import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "circle-thin",
  "use": "circle-thin-usage",
  "viewBox": "0 0 384 448",
  "content": "<symbol viewBox=\"0 0 384 448\" id=\"circle-thin\"><path d=\"M192 64c-88.25 0-160 71.75-160 160s71.75 160 160 160 160-71.75 160-160S280.25 64 192 64zm192 160c0 106-86 192-192 192S0 330 0 224 86 32 192 32s192 86 192 192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/circle-thin.svg
// module id = Pakp
// module chunks = 1